import { useEffect, useState } from "react";
import { LuX } from "react-icons/lu";
import { useIsCompactView } from "../../../core_stores/useIsCompactViewStore";

interface ModalProps {
  canClose: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export function AuthModalLayout({ canClose, onClose, children }: ModalProps) {
  const [isClosing, setIsClosing] = useState(false);
  const isCompactView = useIsCompactView();

  const handleClose = () => {
    if (!canClose) {
      return;
    }
    setIsClosing(true);
    setTimeout(() => {
      onClose();
    }, 300);
  };

  // Handle ESC key to close modal (respects canClose prop)
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        handleClose();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [canClose]);

  return (
    <>
      <div
        className={`${
          isClosing ? "animate-fade-out" : "animate-fade-in"
        } fixed inset-0 
        bg-black/50 transition-opacity duration-300 ease-in-out z-50`}
        onClick={handleClose}
      ></div>
      <div className="fixed inset-0 z-50 flex items-center justify-center">
        <div
          className={`${isClosing ? "animate-fade-out" : "animate-fade-in"} ${
            isCompactView
              ? "w-full h-full"
              : "max-w-[700px] h-[75%] max-h-[400px] rounded-2xl"
          } relative 
          bg-light-surface-primary dark:bg-[#1B1E22]
          transform transition-all duration-300 ease-in-out w-full max-w-5xl overflow-hidden`}
        >
          {canClose && (
            <button
              onClick={handleClose}
              className={`${
                isCompactView
                  ? "text-white hover:text-slate-300"
                  : "text-[#6B7788] hover:text-light-hover dark:text-[#6B7788] dark:hover:text-dark-hover"
              } absolute top-4 right-4 transition-colors z-10`}
            >
              <LuX className="w-5 h-5" />
            </button>
          )}
          {children}
        </div>
      </div>
    </>
  );
}
